import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=8aafbe4a&scoped=true"
import script from "./NotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aafbe4a",
  null
  
)

export default component.exports